module.exports = "/images/aerial-12.jpg";